import axios from "axios";
import { motion } from "framer-motion";
import React, { useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { NavLink } from "react-router-dom";
import VisibilitySensor from "react-visibility-sensor";
import pc4 from "../../assets/images/pc4.png";
import Spacer from "../../components/Utils/Spacer";
import { Context } from "../../context";
import TitleHome from "../Utils/TitleHome";
import classes from "./Project.module.css";
const url = "https://www.aroundweb.it/davidebalice.dev/data/demo.json";

const ProjectHome = () => {
  const [demoData, setDemoData] = useState([]);
  const { debug, lang } = useContext(Context);

  const getData = async () => {
    try {
      const response = await axios.get(url);
      setDemoData(response.data);
    } catch (e) {
      if (debug) console.error("ProjectHome API offline:", e.message);
    }
  };

  const [isVisible, setIsVisible] = useState(false);

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <section
        id="projectHome"
        className={classes.bgProject + " section p_zero"}
      >
        <div className="text-left py-5">
          <Container>
            <div className="position-relative d-flex mb-2">
              <div className="container">
                <TitleHome text="Projects({ projects })" color="white" />
              </div>
            </div>
          </Container>
          <div className="container row m-auto">
            <div className="col-md-6" style={{ textAlign: "left" }}>
              <VisibilitySensor
                onChange={changeVisibility}
                partialVisibility
                delayedCall
              >
                <motion.p
                  initial={{ opacity: 0, y: 12 }}
                  animate={{
                    opacity: isVisible ? 1 : 0,
                    y: isVisible ? 1 : 0,
                  }}
                  className="text-6 text-white w-100 mb-0 mt-4"
                  transition={{ duration: 0.4, delay: 0.8 }}
                >
                  {lang === "en" && <>Projects</>}
                  {lang === "it" && <>Progetti</>}
                </motion.p>
              </VisibilitySensor>

              <VisibilitySensor
                onChange={changeVisibility}
                partialVisibility
                delayedCall
              >
                <motion.p
                  initial={{ opacity: 0, y: 12 }}
                  animate={{
                    opacity: isVisible ? 1 : 0,
                    y: isVisible ? 1 : 0,
                  }}
                  className="text-4 text-white w-100 mb-0"
                  transition={{ duration: 0.4, delay: 1 }}
                >
                  These projects have been developed in recent years, include
                  entire cms, graphic editors, booking software for tourism,
                  ecommerce and more. There are just some of the projects
                  developed.
                  {lang === "en" && (
                    <>
                      {" "}
                      These projects have been developed in recent years,
                      include entire cms, graphic editors, booking software for
                      tourism, ecommerce and more. There are just some of the
                      projects developed.
                    </>
                  )}
                  {lang === "it" && (
                    <>
                      Questi progetti sono stati sviluppati negli ultimi anni,
                      includono interi cms, editor grafici, software di
                      prenotazione per il turismo, e-commerce e altro ancora.
                      Sono solo alcuni dei progetti sviluppati.
                    </>
                  )}
                </motion.p>
              </VisibilitySensor>

              <Spacer height="70" />
              <NavLink
                to="/project"
                className={classes.projectButton + " nav-link smooth-scroll"}
              >
                <VisibilitySensor
                  onChange={changeVisibility}
                  partialVisibility
                  delayedCall
                >
                  <motion.span
                    initial={{ opacity: 0, y: 12 }}
                    animate={{
                      opacity: isVisible ? 1 : 0,
                      y: isVisible ? 1 : 0,
                    }}
                    className="btn btn-outline-primary rounded-pill shadow-none smooth-scroll"
                    transition={{ duration: 0.4, delay: 1.2 }}
                  >
                    View projects
                    {lang === "en" && <></>}
                    {lang === "it" && <></>}
                  </motion.span>
                </VisibilitySensor>
              </NavLink>
            </div>
            <div className="col-md-6">
              <img src={pc4} alt="" className={classes.projectImgHome} />
            </div>
            <Spacer height="20" />
            <div className={classes.textCode1}>{`}`}</div>
          </div>
        </div>

        <Spacer height="20" />
        <script src="vendor/jquery/jquery.min.js"></script>
        <script src="vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
        <script src="js/theme.js"></script>
      </section>
    </>
  );
};

export default ProjectHome;
